/*
 * Click-to-load facade for the BRCE Video section.
 *
 * YouTube and Vimeo ignore the poster attribute, and their players pull in a
 * few hundred KB of third-party JavaScript on page load. This element shows the
 * merchant's own poster image instead and only swaps in the iframe once someone
 * presses play - so the poster choice is honoured for every source type and the
 * embed costs nothing until it is actually wanted.
 */
class BrceVideoFacade extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;

    this.addEventListener('click', this.load.bind(this), { once: true });

    const button = this.querySelector('button');
    if (button) {
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.load();
        }
      });
    }
  }

  load() {
    const src = this.dataset.embedSrc;
    if (!src || this.dataset.loaded === 'true') return;

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', this.dataset.embedTitle || 'Video');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');

    this.replaceChildren(iframe);
    this.dataset.loaded = 'true';
    this.style.cursor = 'default';
  }
}

if (!customElements.get('brce-video-facade')) {
  customElements.define('brce-video-facade', BrceVideoFacade);
}
